import { render, staticRenderFns } from "./NotesManager.vue?vue&type=template&id=2bff8778&scoped=true&"
import script from "./NotesManager.vue?vue&type=script&lang=js&"
export * from "./NotesManager.vue?vue&type=script&lang=js&"
import style0 from "./NotesManager.vue?vue&type=style&index=0&id=2bff8778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff8778",
  null
  
)

export default component.exports